jQuery(document).ready(function($) {
  var $hamburger = $('.hamburger');
  var $drawerMenu = $('.b-drawer-menu');
  var $searchOverlay = $('.b-search-overlay');
  var $searchBtns = $('.b-header__search-btn');
  var headerHeight = Math.ceil($('header').outerHeight());

  function positionDrawer() {
    if($('body').hasClass('admin-bar')){
      headerHeight += 46;
    }
    $drawerMenu.css({
      'top': headerHeight + 'px',
      'height': 'calc(100vh - ' + headerHeight + 'px)'
    });
  }

  positionDrawer();

  // All headers: toggles .is-scrolled once the page has scrolled. The hero
  // variant (see .b-header--hero in _header.scss) uses it to swap the
  // transparent hero overlay for a solid background, since it's fixed in
  // place instead of scrolling away with the hero image. Both variants use
  // it to shrink the logo and nav padding on desktop.
  var $header = $('.b-header');
  if ($header.length) {
    var updateHeaderScrolled = function() {
      $header.toggleClass('is-scrolled', window.pageYOffset > 10);
    };
    updateHeaderScrolled();
    $(window).on('scroll', updateHeaderScrolled);
  }

  // Locks page scroll while either full-screen overlay (menu or search) is open.
  function updateBodyScroll() {
    if ($drawerMenu.hasClass('open') || $searchOverlay.hasClass('open')) {
      $('body').css({ 'overflow': 'hidden', 'height': '100vh' });
    } else {
      $('body').css({ 'overflow': '', 'height': '' });
    }
  }

  $hamburger.click(function() {
    $drawerMenu.toggleClass('open');
    var isOpen = $drawerMenu.hasClass('open');

    $hamburger.toggleClass('open', isOpen);
    $hamburger.attr('aria-expanded', isOpen);

    if (isOpen) {
      headerHeight = Math.ceil($('header').outerHeight());
      positionDrawer();
      $searchOverlay.removeClass('open');
    }

    updateBodyScroll();
  });

  $(window).resize(function() {
    if ($drawerMenu.hasClass('open')) {
      headerHeight = Math.ceil($('header').outerHeight());
      positionDrawer();
    }
  });

  $searchBtns.on('click', function() {
    $drawerMenu.removeClass('open');
    $hamburger.removeClass('open').attr('aria-expanded', false);

    $searchOverlay.addClass('open');
    updateBodyScroll();
    $searchOverlay.find('.b-search-overlay__input').trigger('focus');
  });

  $('.b-search-overlay__close').on('click', function() {
    $searchOverlay.removeClass('open');
    updateBodyScroll();
  });

  // Click on the backdrop (outside the form itself) closes the overlay
  $searchOverlay.on('click', function(e) {
    if (e.target === this) {
      $searchOverlay.removeClass('open');
      updateBodyScroll();
    }
  });

  $(document).on('keydown', function(e) {
    if (e.key === 'Escape' && $searchOverlay.hasClass('open')) {
      $searchOverlay.removeClass('open');
      updateBodyScroll();
    }
  });

  // Toggles the accordion panel next to a .menu-toggle button — the panel
  // (.drawer-sublist, reused at every nesting level) is always a sibling
  // within the same item, so match on class rather than position.
  function slideToggleSubNav(menuToggle) {
    var isExpanded = $(menuToggle).attr('aria-expanded') === 'true';
    $(menuToggle).attr('aria-expanded', !isExpanded);
    $(menuToggle).toggleClass('active');
    $(menuToggle).siblings('.drawer-sublist').slideToggle();
  }

  function showSubNav(menuToggle) {
    var isExpanded = $(menuToggle).attr('aria-expanded') === 'true';
    $(menuToggle).attr('aria-expanded', !isExpanded);
    $(menuToggle).toggleClass('active');
    $(menuToggle).next('ul').toggleClass('active');
  }

  $('.menu-toggle', $('.b-header__menu__primary-menu')).on('click', function(){
    slideToggleSubNav(this);
  });

  $('.menu-toggle', $('.b-drawer-menu')).on('click', function(){
    slideToggleSubNav(this);
  });

  $('.menu-toggle', $('.b-header__top-bar')).on('click', function(){
    showSubNav(this);
  });

  // Hero videos are rendered with <source data-src> (see render_hero_block)
  // so only the one for the current viewport downloads. 768px must match the
  // `medium` breakpoint that swaps the desktop/mobile media in _b-hero-primary.scss.
  var tabletUp = window.matchMedia('(min-width: 768px)');

  function loadHeroVideos() {
    $('.block-hero__media video').each(function() {
      var isDesktop = $(this).closest('.block-hero__media--desktop').length > 0;

      // Pause the one hidden by CSS after a resize across the breakpoint
      if (isDesktop !== tabletUp.matches) {
        this.pause();
        return;
      }

      // The inline script after the hero only sets the poster for the slot
      // visible at load (see render_hero_block)
      if (!this.getAttribute('poster') && $(this).data('poster')) {
        this.poster = $(this).data('poster');
      }

      var $source = $(this).find('source[data-src]');
      if ($source.length && !$source.attr('src')) {
        $source.attr('src', $source.data('src'));
        this.load();
      }

      var playing = this.play();
      if (playing && playing.catch) {
        playing.catch(function() {});
      }
    });
  }

  loadHeroVideos();
  if (tabletUp.addEventListener) {
    tabletUp.addEventListener('change', loadHeroVideos);
  }

  // Autoplay core Video blocks are rendered with data-src (see
  // render_core_video_block). Load and start each one as it nears the screen.
  var $lazyVideos = $('.wp-block-video video[data-src]');

  function loadLazyVideo(video) {
    video.src = $(video).data('src');
    $(video).removeAttr('data-src');

    if ($(video).data('autoplay')) {
      video.autoplay = true;
      var playing = video.play();
      if (playing && playing.catch) {
        playing.catch(function() {});
      }
    }
  }

  if ($lazyVideos.length) {
    if ('IntersectionObserver' in window) {
      var videoObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            videoObserver.unobserve(entry.target);
            loadLazyVideo(entry.target);
          }
        });
      }, { rootMargin: '400px 0px' });

      $lazyVideos.each(function() {
        videoObserver.observe(this);
      });
    } else {
      $lazyVideos.each(function() {
        loadLazyVideo(this);
      });
    }
  }

  // Spotlight Instagram scripts are printed as type="gcs/lazy" (see
  // lazy_spotlight_scripts). Load them when the feed nears the viewport.
  var $lazyScripts = $('script[type="gcs/lazy"]');
  var $instaFeeds = $('.spotlight-instagram-feed');

  function loadSpotlight() {
    var total = $lazyScripts.length;
    var loaded = 0;

    $lazyScripts.each(function() {
      var script = document.createElement('script');
      script.src = $(this).data('src');
      script.async = false; // download in parallel, run in order
      script.onload = script.onerror = function() {
        loaded++;
        // Spotlight boots on DOMContentLoaded, which has already fired
        if (loaded === total && window.SpotlightInstagram) {
          window.SpotlightInstagram.init();
        }
      };
      document.body.appendChild(script);
    });
  }

  if ($lazyScripts.length && $instaFeeds.length) {
    if ('IntersectionObserver' in window) {
      var instaObserver = new IntersectionObserver(function(entries) {
        if (entries.some(function(entry) { return entry.isIntersecting; })) {
          instaObserver.disconnect();
          loadSpotlight();
        }
      }, { rootMargin: '600px 0px' });

      $instaFeeds.each(function() {
        instaObserver.observe(this);
      });
    } else {
      loadSpotlight();
    }
  }
});
